import React from 'react';

export const inputCls =
  'w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#E07A2C] focus:border-transparent outline-none text-sm';

export const Field = ({ label, hint, testid, children, required }) => (
  <div data-testid={testid}>
    <label className="block text-sm font-medium text-gray-700 mb-2">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    {children}
    {hint && <p className="text-xs text-gray-500 mt-1">{hint}</p>}
  </div>
);

export const Input = ({ value, onChange, ...rest }) => (
  <input value={value || ''} onChange={(e) => onChange(e.target.value)} className={inputCls} {...rest} />
);

export const TextArea = ({ value, onChange, rows = 3, ...rest }) => (
  <textarea value={value || ''} onChange={(e) => onChange(e.target.value)} rows={rows} className={inputCls} {...rest} />
);

export const Select = ({ value, onChange, options, placeholder = 'Select...', ...rest }) => (
  <select value={value || ''} onChange={(e) => onChange(e.target.value)} className={inputCls} {...rest}>
    <option value="">{placeholder}</option>
    {options.map((o) =>
      typeof o === 'string' ? (
        <option key={o} value={o}>{o}</option>
      ) : (
        <option key={o.value} value={o.value}>{o.label}</option>
      )
    )}
  </select>
);

export const RadioGroup = ({ value, onChange, options, name, testid }) => (
  <div className="space-y-2" data-testid={testid}>
    {options.map((opt) => {
      const v = typeof opt === 'string' ? opt : opt.value;
      const label = typeof opt === 'string' ? opt : opt.label;
      const checked = value === v;
      return (
        <label
          key={v}
          className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-colors ${
            checked ? 'border-[#E07A2C] bg-[#FFF6EE]' : 'border-gray-200 hover:bg-gray-50'
          }`}
        >
          <input
            type="radio"
            name={name}
            value={v}
            checked={checked}
            onChange={() => onChange(v)}
            className="accent-[#E07A2C]"
          />
          <span className="text-sm">{label}</span>
        </label>
      );
    })}
  </div>
);

export const Toggle = ({ value, onChange, label, testid }) => (
  <label className="flex items-start gap-3 p-3 border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50" data-testid={testid}>
    <input
      type="checkbox"
      checked={!!value}
      onChange={(e) => onChange(e.target.checked)}
      className="mt-1 accent-[#E07A2C]"
    />
    <span className="text-sm">{label}</span>
  </label>
);

export const YesNo = ({ value, onChange, testid }) => (
  <Select
    value={value}
    onChange={onChange}
    options={[{ value: 'yes', label: 'Yes' }, { value: 'no', label: 'No' }]}
    data-testid={testid}
  />
);

export const SectionHeader = ({ index, title, subtitle }) => (
  <div className="mb-5">
    <div className="text-xs font-semibold uppercase tracking-[0.2em] mb-1" style={{ color: '#E07A2C' }}>
      Step {index}
    </div>
    <h2 className="text-2xl font-bold" style={{ color: '#01325B' }}>{title}</h2>
    {subtitle && <p className="text-sm text-gray-600 mt-1">{subtitle}</p>}
  </div>
);

export const ProgressBar = ({ step, total }) => {
  const pct = Math.round(((step + 1) / total) * 100);
  return (
    <div data-testid="profile-progress" className="mb-6">
      <div className="flex items-center justify-between text-xs text-gray-600 mb-2">
        <span>Step {step + 1} of {total}</span>
        <span>{pct}% complete</span>
      </div>
      <div className="h-2 w-full bg-gray-200 rounded-full overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-300"
          style={{ width: `${pct}%`, background: '#E07A2C' }}
        />
      </div>
    </div>
  );
};
